import React from 'react';

const CalendarDayPlaceholder = React.memo(() => <div className="relative bg-white">
	<div className="flex flex-col justify-between h-full">
		<div className="px-3 py-2">
			<time dateTime="2024-01-11"></time>
		</div>
		<div className="px-3 py-2">
			<div className="w-full animate-pulse">
				<div className="h-4 bg-gray-200 rounded-full w-12 mb-4"></div>
				<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
				<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
				<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
				<div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
			</div>
		</div>
	</div>
</div>);

export default CalendarDayPlaceholder;